__turbopack_context__.v({
  "ColorSwatches": "ColorSwatches-module-scss-module__os6Pqq__ColorSwatches",
  "colorSwatch": "ColorSwatches-module-scss-module__os6Pqq__colorSwatch",
  "selected": "ColorSwatches-module-scss-module__os6Pqq__selected",
  "swatches-picker": "ColorSwatches-module-scss-module__os6Pqq__swatches-picker",
  "swatchesContainer": "ColorSwatches-module-scss-module__os6Pqq__swatchesContainer",
  "swatchesGrid": "ColorSwatches-module-scss-module__os6Pqq__swatchesGrid",
});
